import { pinyin } from 'pinyin-pro';
export function lineToUppercase(str) {
    function upper(all, letter) {
        return letter.toUpperCase();
    }
    return str.replace(/-(\w)/g, upper);
}
export function groupCitiesByInitial(cities) {
    const cityGroups = {};
    cities.forEach(city => {
        const initial = getFirstWord(city.address);
        if (!cityGroups[initial]) {
            cityGroups[initial] = [];
        }
        cityGroups[initial].push(city);
    });
    return Object.keys(cityGroups)
        .sort()
        .reduce((sortedGroups, initial) => {
        sortedGroups[initial] = cityGroups[initial];
        return sortedGroups;
    }, {});
}
function getFirstWord(str) {
    if (!str) {
        return '';
    }
    return pinyin(str, { pattern: "first", toneType: "none" })[0].toUpperCase();
}
